const styles = () => ({
  supressionForm: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 25,
    paddingBottom: 8,
  },

  selectLabel: {
    position: 'relative',
    top: -7,
  },

  select: {
    '&&': {
      marginTop: 0,
    },
  },

  number: {
    maxWidth: 58,
    marginRight: 33,
  },

  checkbox: {
    marginRight: 0,
    paddingRight: 13,
    padding: '0 13px 0 12px',
  },

  checklabel: {
    fontSize: 15,
    color: '#27282a',
  },
});

export default styles;
